import { TractorClient } from '@src/tractor/services/TractorClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface Props {
  clientId: string;
  tractorId: string;
  onSuccess: () => void;
  onError: () => void;
}

export const useDeleteTractor = ({
  clientId,
  tractorId,
  onSuccess,
  onError,
}: Props) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: async () => {
      await TractorClient.delete(clientId, tractorId);
    },
    onSuccess: async () => {
      onSuccess();
      await queryClient.invalidateQueries({
        queryKey: ['tractors.list', clientId],
      });
    },
    onError,
  });

  return {
    deleteTractor: mutate,
    isLoading: isPending,
  };
};
